import React, { useState } from 'react';
import BaseModal from 'src/common/components/Modal';
import UtilInputs from 'src/common/components/UtilInputs';
import notice from 'src/common/components/Notice';
import { defaultBody, newBodyForm } from '../utils/list_data';
import { institutionsAPI } from 'src/api/modules/institutions';

const AddOrg = ({ open, onClose, onSuccess }) => {
	const [dataForm, setDataForm] = useState(defaultBody);

	const handleChange = ({ target }) =>
		setDataForm({ ...dataForm, [target.name]: target.value });

	const onSaveData = () => {
		institutionsAPI
			.institutionCreate('OR', dataForm.nombreOrganizacion)
			.then(() => {
				onSuccess('Organización creada', 'success', 1);
				setDataForm(defaultBody);
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Agregar nueva organización"
			confirmLabel="Guardar"
			onConfirm={onSaveData}
			onClose={() => {
				onClose();
				setDataForm(defaultBody);
			}}
			onCancel={() => {
				onClose();
				setDataForm(defaultBody);
			}}
		>
			<UtilInputs
				formValues={dataForm}
				inputValues={newBodyForm}
				onValuesChange={handleChange}
			/>
		</BaseModal>
	);
};

export default AddOrg;
